import {getOverrideStatus} from './libVersionManager';
import type {LibName} from './libVersionManager';

// A runtime version override replaces which library code actually
// executes; report the loaded bundle's own version, not the built-in one.
const withOverride = (lib: LibName, builtInVersion: string): string => {
  const status = getOverrideStatus(lib);
  return (status?.state === 'active' && status.loadedVersion) || builtInVersion;
};

// Resolved (not range) versions of the ergeon packages, keyed by short name.
// Mirrors the set shown in the draft-editor "About" dialog so the versions we
// surface to users and the versions we report to Sentry stay in sync. The map
// is injected at build time from the installed package manifests
// (vite.config.ts getErgeonPackageVersions), so reading it does not pull the
// packages themselves into the entry chunk.
export const parsePackageVersionTags = (raw?: string): Record<string, string> => {
  try {
    return JSON.parse(raw ?? '{}');
  } catch {
    return {};
  }
};

export const getPackageVersionTags = (): Record<string, string> => {
  const builtIn = parsePackageVersionTags(import.meta.env.ERGEON_PACKAGE_VERSIONS);
  // Layer runtime overrides over the build-time map: for a switchable library
  // the loaded bundle may report a different version than its package.json.
  return {
    ...builtIn,
    '3d-lib': withOverride('3d-lib', builtIn['3d-lib']),
    'draft-editor': withOverride('draft-editor', builtIn['draft-editor']),
  };
};
